import * as i6 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { EventEmitter, Component, ViewEncapsulation, ChangeDetectionStrategy, Input, Output, NgModule } from '@angular/core';
import * as i2 from '@angular/router';
import { RouterModule } from '@angular/router';
import { parseUrl, fromSearchString, getNumbers } from '@js-dot/core';
import * as i3 from '@ng-dot/route';
import { DotSelfUrlService } from '@ng-dot/route';
import * as i7 from '@ng-dot/ui/icon';
import { DotIconModule } from '@ng-dot/ui/icon';
import * as i5 from '@ng-dot/ui/link';
import { DotLinkModule } from '@ng-dot/ui/link';
import * as i4 from '@ng-dot/ui/trans';
import { DotTransDirective } from '@ng-dot/ui/trans';
import { Subject, BehaviorSubject } from 'rxjs';
import { takeUntil, debounceTime } from 'rxjs/operators';
import * as i1 from '@ng-dot/ux/paginate';
function DotPageLinksComponent_Conditional_0_Case_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 2)(1, "button", 6);
    i0.ɵɵpipe(2, "icon");
    i0.ɵɵlistener("click", function DotPageLinksComponent_Conditional_0_Case_0_Conditional_1_Template_button_click_1_listener() {
      const link_r2 = i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.changed$.emit(link_r2.page));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(2, 1, ctx_r2.icons.before, ctx.page), i0.ɵɵsanitizeHtml);
  }
}
function DotPageLinksComponent_Conditional_0_Case_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 3)(1, "button", 6);
    i0.ɵɵpipe(2, "icon");
    i0.ɵɵlistener("click", function DotPageLinksComponent_Conditional_0_Case_0_Conditional_3_Template_button_click_1_listener() {
      const link_r5 = i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.changed$.emit(link_r5.page));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(2, 1, ctx_r2.icons.previous, ctx.page), i0.ɵɵsanitizeHtml);
  }
}
function DotPageLinksComponent_Conditional_0_Case_0_For_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "button", 7);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵlistener("click", function DotPageLinksComponent_Conditional_0_Case_0_For_6_Template_button_click_1_listener() {
      const link_r7 = i0.ɵɵrestoreView(_r6).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.changed$.emit(link_r7.page));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const link_r7 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("_active", i0.ɵɵpipeBind1(2, 3, ctx_r2.actives$[link_r7.page]));
    i0.ɵɵproperty("textContent", link_r7.page);
  }
}
function DotPageLinksComponent_Conditional_0_Case_0_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 4)(1, "button", 6);
    i0.ɵɵpipe(2, "icon");
    i0.ɵɵlistener("click", function DotPageLinksComponent_Conditional_0_Case_0_Conditional_7_Template_button_click_1_listener() {
      const link_r9 = i0.ɵɵrestoreView(_r8);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.changed$.emit(link_r9.page));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(2, 1, ctx_r2.icons.next, ctx.page), i0.ɵɵsanitizeHtml);
  }
}
function DotPageLinksComponent_Conditional_0_Case_0_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 5)(1, "button", 6);
    i0.ɵɵpipe(2, "icon");
    i0.ɵɵlistener("click", function DotPageLinksComponent_Conditional_0_Case_0_Conditional_9_Template_button_click_1_listener() {
      const link_r11 = i0.ɵɵrestoreView(_r10);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.changed$.emit(link_r11.page));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(2, 1, ctx_r2.icons.after, ctx.page), i0.ɵɵsanitizeHtml);
  }
}
function DotPageLinksComponent_Conditional_0_Case_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 0);
    i0.ɵɵtemplate(1, DotPageLinksComponent_Conditional_0_Case_0_Conditional_1_Template, 3, 4, "li", 2);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtemplate(3, DotPageLinksComponent_Conditional_0_Case_0_Conditional_3_Template, 3, 4, "li", 3);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵrepeaterCreate(5, DotPageLinksComponent_Conditional_0_Case_0_For_6_Template, 3, 5, "li", null, i0.ɵɵcomponentInstance().usingTarget, true);
    i0.ɵɵtemplate(7, DotPageLinksComponent_Conditional_0_Case_0_Conditional_7_Template, 3, 4, "li", 4);
    i0.ɵɵpipe(8, "async");
    i0.ɵɵtemplate(9, DotPageLinksComponent_Conditional_0_Case_0_Conditional_9_Template, 3, 4, "li", 5);
    i0.ɵɵpipe(10, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_2_0;
    let tmp_3_0;
    let tmp_5_0;
    let tmp_6_0;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional((tmp_2_0 = i0.ɵɵpipeBind1(2, 4, ctx_r2.vars.first$)) ? 1 : -1, tmp_2_0);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional((tmp_3_0 = i0.ɵɵpipeBind1(4, 6, ctx_r2.vars.prev$)) ? 3 : -1, tmp_3_0);
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r2.links);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional((tmp_5_0 = i0.ɵɵpipeBind1(8, 8, ctx_r2.vars.next$)) ? 7 : -1, tmp_5_0);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional((tmp_6_0 = i0.ɵɵpipeBind1(10, 10, ctx_r2.vars.last$)) ? 9 : -1, tmp_6_0);
  }
}
function DotPageLinksComponent_Conditional_0_Case_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 2);
    i0.ɵɵelement(1, "a", 8);
    i0.ɵɵpipe(2, "icon");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const link_r12 = ctx;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", ctx_r2.path)("queryParams", link_r12.query)("innerHTML", i0.ɵɵpipeBind2(2, 3, ctx_r2.icons.before, link_r12.page), i0.ɵɵsanitizeHtml);
  }
}
function DotPageLinksComponent_Conditional_0_Case_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 3);
    i0.ɵɵelement(1, "a", 8);
    i0.ɵɵpipe(2, "icon");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const link_r13 = ctx;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", ctx_r2.path)("queryParams", link_r13.query)("innerHTML", i0.ɵɵpipeBind2(2, 3, ctx_r2.icons.previous, link_r13.page), i0.ɵɵsanitizeHtml);
  }
}
function DotPageLinksComponent_Conditional_0_Case_1_For_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelement(1, "a", 9);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const link_r14 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("_active", i0.ɵɵpipeBind1(2, 5, ctx_r2.actives$[link_r14.page]));
    i0.ɵɵproperty("routerLink", ctx_r2.path)("queryParams", link_r14.query)("textContent", link_r14.page);
  }
}
function DotPageLinksComponent_Conditional_0_Case_1_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 4);
    i0.ɵɵelement(1, "a", 8);
    i0.ɵɵpipe(2, "icon");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const link_r15 = ctx;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", ctx_r2.path)("queryParams", link_r15.query)("innerHTML", i0.ɵɵpipeBind2(2, 3, ctx_r2.icons.next, link_r15.page), i0.ɵɵsanitizeHtml);
  }
}
function DotPageLinksComponent_Conditional_0_Case_1_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 5);
    i0.ɵɵelement(1, "a", 8);
    i0.ɵɵpipe(2, "icon");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const link_r16 = ctx;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", ctx_r2.path)("queryParams", link_r16.query)("innerHTML", i0.ɵɵpipeBind2(2, 3, ctx_r2.icons.after, link_r16.page), i0.ɵɵsanitizeHtml);
  }
}
function DotPageLinksComponent_Conditional_0_Case_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 1);
    i0.ɵɵtemplate(1, DotPageLinksComponent_Conditional_0_Case_1_Conditional_1_Template, 3, 6, "li", 2);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtemplate(3, DotPageLinksComponent_Conditional_0_Case_1_Conditional_3_Template, 3, 6, "li", 3);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵrepeaterCreate(5, DotPageLinksComponent_Conditional_0_Case_1_For_6_Template, 3, 7, "li", null, i0.ɵɵcomponentInstance().usingTarget, true);
    i0.ɵɵtemplate(7, DotPageLinksComponent_Conditional_0_Case_1_Conditional_7_Template, 3, 6, "li", 4);
    i0.ɵɵpipe(8, "async");
    i0.ɵɵtemplate(9, DotPageLinksComponent_Conditional_0_Case_1_Conditional_9_Template, 3, 6, "li", 5);
    i0.ɵɵpipe(10, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_2_0;
    let tmp_3_0;
    let tmp_5_0;
    let tmp_6_0;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional((tmp_2_0 = i0.ɵɵpipeBind1(2, 4, ctx_r2.vars.first$)) ? 1 : -1, tmp_2_0);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional((tmp_3_0 = i0.ɵɵpipeBind1(4, 6, ctx_r2.vars.prev$)) ? 3 : -1, tmp_3_0);
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r2.links);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional((tmp_5_0 = i0.ɵɵpipeBind1(8, 8, ctx_r2.vars.next$)) ? 7 : -1, tmp_5_0);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional((tmp_6_0 = i0.ɵɵpipeBind1(10, 10, ctx_r2.vars.last$)) ? 9 : -1, tmp_6_0);
  }
}
function DotPageLinksComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DotPageLinksComponent_Conditional_0_Case_0_Template, 11, 12, "ul", 0)(1, DotPageLinksComponent_Conditional_0_Case_1_Template, 11, 12, "ul", 1);
  }
  if (rf & 2) {
    let tmp_1_0;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵconditional((tmp_1_0 = ctx_r2.type) === "button" ? 0 : 1);
  }
}
class DotPageLinksComponent {
  _pagination;
  _changeDetectorRef;
  _router;
  _routeEvent;
  type = 'anchor';
  set meta(meta) {
    this.total = meta['total'];
    this.page = meta['page'] || 1;
    this.limit = meta['limit'];
    this.update$.next();
  }
  total;
  page = 1;
  limit = 24;
  set linkLimit(value) {
    if (value) {
      this._linkLimit = value;
    }
  }
  get linkLimit() {
    return this._linkLimit;
  }
  extend;
  path = './';
  changed$ = new EventEmitter();
  _caster;
  _destroy$ = new Subject();
  _linkLimit = 10;
  update$ = new Subject();
  lastActive$;
  init$ = new BehaviorSubject(false);
  firstPage$ = new BehaviorSubject(null);
  lastPage$ = new BehaviorSubject(null);
  prevBlock$ = new BehaviorSubject(null);
  nextBlock$ = new BehaviorSubject(null);
  actives$ = {};
  links;
  vars = {
    init$: this.init$,
    first$: this.firstPage$,
    last$: this.lastPage$,
    prev$: this.prevBlock$,
    next$: this.nextBlock$
  };
  _url;
  _lastUrl;
  _queries;
  _totalPage;
  _blockStart;
  _blockEnd;
  lastTotal;
  lastLimit;
  get icons() {
    return this._pagination.configure.icons;
  }
  constructor(_pagination, _changeDetectorRef, _router, _routeEvent
  // protected _url: DotSelfUrlService
  ) {
    this._pagination = _pagination;
    this._changeDetectorRef = _changeDetectorRef;
    this._router = _router;
    this._routeEvent = _routeEvent;
  }
  usingTarget(target, index) {
    return target;
  }
  ngOnInit() {
    const {
      _destroy$
    } = this;
    this._updateQuery(parseUrl(this._router.url).search);
    this._routeEvent.ended$.pipe(takeUntil(_destroy$)).subscribe(url => {
      this._updateQuery(url);
    });
    this.update$.pipe(takeUntil(_destroy$), debounceTime(240)).subscribe(() => {
      this._update();
    });
    // this._url.get$<number>('$page')
    // 	.subscribe(page => {
    // 		if (this.page !== page) {
    // 			this.page = page;
    // 		}
    // 	});
    this._update();
    this.init$.next(true);
  }
  ngOnChanges(changes) {
    for (let key in changes) {
      if (!changes.hasOwnProperty(key)) {
        continue;
      }
      const change = changes[key];
      this[key] = change.currentValue;
      if (!this.init$.value) {
        return;
      }
      switch (key) {
        case 'meta':
        case 'total':
        case 'page':
        case 'limit':
        case 'blockLimit':
          this.update$.next();
      }
    }
  }
  _updateQuery(url) {
    this._url = url;
    this._queries = fromSearchString(url || '');
    this._update();
  }
  _update() {
    const {
      total,
      limit,
      linkLimit
    } = this;
    const page = +this.page || 1;
    if (!total) {
      return null;
    }
    // same link
    if (this._url === this._lastUrl && this.lastTotal === total && this.lastLimit === limit && page >= this._blockStart && page <= this._blockEnd) {
      return this.selectPage(page);
    }
    this._lastUrl = this._url;
    this.lastTotal = total;
    this.lastLimit = limit;
    const totalPage = Math.ceil(total / limit);
    const block = Math.ceil(page / linkLimit);
    const blockStart = (block - 1) * linkLimit + 1;
    let blockEnd = blockStart + linkLimit - 1;
    this._blockStart = blockStart;
    this._blockEnd = blockEnd;
    if (blockEnd > totalPage) {
      blockEnd = totalPage;
    }
    const {
      actives$
    } = this;
    this.links = getNumbers(blockStart, blockEnd).map(_page => {
      if (!actives$[_page]) {
        actives$[_page] = new BehaviorSubject(false);
      }
      return {
        page: _page,
        query: {
          ...this._queries,
          page: _page
        }
      };
    });
    // previous block page
    const prevBlock = blockStart - 1;
    this.prevBlock$.next(prevBlock - 1 > 1 ? {
      page: prevBlock,
      query: {
        ...this._queries,
        page: prevBlock
      }
    } : null);
    // next block page
    const blockNext = blockEnd + 1;
    this.nextBlock$.next(blockNext < totalPage ? {
      page: blockNext,
      query: {
        ...this._queries,
        page: blockNext
      }
    } : null);
    // first page
    this.firstPage$.next(blockStart !== 1 ? {
      page: 1,
      query: {
        ...this._queries,
        page: 1
      }
    } : null);
    // last page
    this.lastPage$.next(blockEnd !== totalPage ? {
      page: totalPage,
      query: {
        ...this._queries,
        page: totalPage
      }
    } : null);
    this.selectPage(page);
    this._changeDetectorRef.markForCheck();
  }
  selectPage(page) {
    const {
      lastActive$
    } = this;
    const active$ = this.actives$[page];
    if (!active$ || active$ === lastActive$) {
      return;
    }
    if (lastActive$) {
      lastActive$.next(false);
    }
    this.lastActive$ = active$;
    active$.next(true);
    this.changed$.emit(page);
    this.page = page;
  }
  static ɵfac = function DotPageLinksComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotPageLinksComponent)(i0.ɵɵdirectiveInject(i1.DotPaginateService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(i3.DotRouteEventService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotPageLinksComponent,
    selectors: [["dot-page-links"]],
    inputs: {
      type: "type",
      meta: "meta",
      total: "total",
      page: "page",
      limit: "limit",
      linkLimit: "linkLimit",
      extend: "extend",
      path: "path"
    },
    outputs: {
      changed$: "changed$"
    },
    standalone: false,
    features: [i0.ɵɵProvidersFeature([DotSelfUrlService]), i0.ɵɵNgOnChangesFeature],
    decls: 2,
    vars: 3,
    consts: [["dotTrans", "u-", 1, "dot-page-links"], ["dotTrans", "bdf-", 1, "dot-page-links"], [1, "_first"], [1, "_previous"], [1, "_next"], [1, "_last"], ["dot-link", "", "type", "button", 3, "click", "innerHTML"], ["dot-link", "", "type", "button", 3, "click", "textContent"], [3, "routerLink", "queryParams", "innerHTML"], [3, "routerLink", "queryParams", "textContent"]],
    template: function DotPageLinksComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, DotPageLinksComponent_Conditional_0_Template, 2, 1);
        i0.ɵɵpipe(1, "async");
      }
      if (rf & 2) {
        i0.ɵɵconditional(i0.ɵɵpipeBind1(1, 1, ctx.vars.init$) ? 0 : -1);
      }
    },
    dependencies: [i2.RouterLink, i4.TransDirective, i5.DotLinkComponent, i6.AsyncPipe, i7.DotIconPipe],
    styles: [".dot-page-links{margin:.626em 0;display:flex;justify-content:center}.dot-page-links li{margin:0 .626em}.dot-page-links a{border:solid 2px transparent}.dot-page-links ._active{font-weight:700}.dot-page-links ._first{margin-right:2em}.dot-page-links ._previous{margin-right:1.25em}.dot-page-links ._next{margin-left:1.25em}.dot-page-links ._end{margin-left:2em}\n", ".dot-page-links{align-items:center}.dot-page-links a,.dot-page-links button{display:inline-block}.dot-page-links ._next a .icons,.dot-page-links ._next button .icons,.dot-page-links ._last a .icons,.dot-page-links ._last button .icons{display:flex;flex-direction:row-reverse;align-items:center}.dot-page-links ._next a .icon-label,.dot-page-links ._next button .icon-label,.dot-page-links ._last a .icon-label,.dot-page-links ._last button .icon-label{margin-left:0;margin-right:.313em}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotPageLinksComponent, [{
    type: Component,
    args: [{
      selector: 'dot-page-links',
      template: `
		@if (vars.init$ | async) {
			@switch (type) {
				@default {
					<ul class="dot-page-links" dotTrans="bdf-">
						@if (vars.first$ | async; as link) {
							<li class="_first">
								<a [routerLink]="path" [queryParams]="link.query"
								   [innerHTML]="icons.before | icon: link.page"
								></a>
							</li>
						}
						@if (vars.prev$ | async; as link) {
							<li class="_previous">
								<a [routerLink]="path" [queryParams]="link.query"
								   [innerHTML]="icons.previous | icon: link.page"
								></a>
							</li>
						}
						@for (link of links; track usingTarget($index, link)) {
							<li>
								<a [routerLink]="path"
								   [queryParams]="link.query"
								   [class._active]="actives$[link.page] | async"
								   [textContent]="link.page"
								>
								</a>
							</li>
						}
						@if (vars.next$ | async; as link) {
							<li class="_next">
								<a [routerLink]="path" [queryParams]="link.query"
								   [innerHTML]="icons.next | icon: link.page "
								></a>
							</li>
						}
						@if (vars.last$ | async; as link) {
							<li class="_last">
								<a [routerLink]="path" [queryParams]="link.query"
								   [innerHTML]="icons.after | icon: link.page"
								></a>
							</li>
						}
					</ul>
				}
				@case ('button') {
					<ul class="dot-page-links" dotTrans="u-">
						@if (vars.first$ | async; as link) {
							<li class="_first">
								<button dot-link
										type="button"
										[innerHTML]="icons.before | icon: link.page"
										(click)="changed$.emit(link.page)"
								></button>
							</li>
						}
						@if (vars.prev$ | async; as link) {
							<li class="_previous">
								<button dot-link
										type="button"
										[innerHTML]="icons.previous | icon: link.page"
										(click)="changed$.emit(link.page)"
								></button>
							</li>
						}
						@for (link of links; track usingTarget($index, link)) {
							<li>
								<button dot-link
										type="button"
										[class._active]="actives$[link.page] | async"
										[textContent]="link.page"
										(click)="changed$.emit(link.page)"
								></button>
							</li>
						}
						@if (vars.next$ | async; as link) {
							<li class="_next">
								<button dot-link
										type="button"
										[innerHTML]="icons.next | icon: link.page"
										(click)="changed$.emit(link.page)"
								></button>
							</li>
						}
						@if (vars.last$ | async; as link) {
							<li class="_last">
								<button dot-link
										type="button"
										[innerHTML]="icons.after | icon: link.page"
										(click)="changed$.emit(link.page)"
								></button>
							</li>
						}
					</ul>
				}
			}
		}
	`,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      providers: [DotSelfUrlService],
      standalone: false,
      styles: [".dot-page-links{margin:.626em 0;display:flex;justify-content:center}.dot-page-links li{margin:0 .626em}.dot-page-links a{border:solid 2px transparent}.dot-page-links ._active{font-weight:700}.dot-page-links ._first{margin-right:2em}.dot-page-links ._previous{margin-right:1.25em}.dot-page-links ._next{margin-left:1.25em}.dot-page-links ._end{margin-left:2em}\n", ".dot-page-links{align-items:center}.dot-page-links a,.dot-page-links button{display:inline-block}.dot-page-links ._next a .icons,.dot-page-links ._next button .icons,.dot-page-links ._last a .icons,.dot-page-links ._last button .icons{display:flex;flex-direction:row-reverse;align-items:center}.dot-page-links ._next a .icon-label,.dot-page-links ._next button .icon-label,.dot-page-links ._last a .icon-label,.dot-page-links ._last button .icon-label{margin-left:0;margin-right:.313em}\n"]
    }]
  }], () => [{
    type: i1.DotPaginateService
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: i2.Router
  }, {
    type: i3.DotRouteEventService
  }], {
    type: [{
      type: Input
    }],
    meta: [{
      type: Input
    }],
    total: [{
      type: Input
    }],
    page: [{
      type: Input
    }],
    limit: [{
      type: Input
    }],
    linkLimit: [{
      type: Input
    }],
    extend: [{
      type: Input
    }],
    path: [{
      type: Input
    }],
    changed$: [{
      type: Output
    }]
  });
})();
class DotPageLinksModule {
  static ɵfac = function DotPageLinksModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotPageLinksModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DotPageLinksModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule, RouterModule, DotTransDirective, DotLinkModule, DotIconModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotPageLinksModule, [{
    type: NgModule,
    args: [{
      declarations: [DotPageLinksComponent],
      imports: [CommonModule, RouterModule, DotTransDirective, DotLinkModule, DotIconModule],
      exports: [DotPageLinksComponent]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { DotPageLinksComponent, DotPageLinksModule };
